export const GET_INPUT_VALUE = 'GET_INPUT_VALUE'
export const ADD_PLAN_TO_LIST = 'ADD_PLAN_TO_LIST'
export const DELETE_PLAN_FROM_LIST = 'DELETE_PLAN_FROM_LIST'